var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-container flex-ct-x",attrs:{"data-title":"使用animation-delay保留动画首帧"}},[_c('ul',{staticClass:"initial-keyframe"},_vm._l((3),function(v){return _c('li',{key:v})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }